import { LitElement, html } from "lit";

import { customElement, state } from "lit/decorators.js";

import { styles } from "./app-layout.css";

import "../app-menu/app-menu";
import "../page-header/page-header";
import "ui-components/feedback/feedback-label";
import { t } from "../../translations/i18n";

const HIDE_MENU_ROUTES = ["live-events/stream", "live-events/create"];

@customElement("app-layout")
export class AppLayout extends LitElement {
  static override styles = styles;

  @state()
  private hideMobileMenu = false;

  private shouldHideMenu(): boolean {
    const path = window.location.pathname.replace(/^\/my\//, "");
    return HIDE_MENU_ROUTES.some((route) => path.startsWith(route));
  }

  private handleRouteChange = () => {
    this.hideMobileMenu = this.shouldHideMenu();
  };

  override connectedCallback() {
    super.connectedCallback();
    this.hideMobileMenu = this.shouldHideMenu();
    window.addEventListener("popstate", this.handleRouteChange);
  }

  override disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("popstate", this.handleRouteChange);
  }

  protected override render() {
    return html`
      <section class="container ${this.hideMobileMenu ? "hide-mobile-menu" : ""}">
        <section class="menu">
          <app-menu></app-menu>
        </section>
        <main class="main">
          <slot></slot>
        </main>
        <feedback-label
          labelButtonText=${t("feedback.feedback")}
          headerText=${t("feedback.headerText")}
          sentimentMessage=${t("feedback.sentimentMessage", { context: "post" })}
          sentimentPrompt=${t("feedback.sentimentPrompt")}
          labelPrompt=${t("feedback.labelPrompt")}
          labelPlaceholder=${t("feedback.labelPlaceholder")}
          labelError=${t("feedback.labelError")}
          successMessage=${t("feedback.successMessage")}
          footerButtonText=${t("feedback.footerButtonText")}
          footerButtonLoadingText=${t("feedback.footerButtonLoadingText")}
        ></feedback-label>
      </section>
    `;
  }
}
